<template>
  <v-app id="inspire" ref="app">
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-app-bar-nav-icon
        color="primary"
        class="mobile-burger hidden-md-and-up"
        @click.stop="
          drawer = !drawer;
          showSearchField = false;
          showFilters = false;
        "
      />
      <div v-if="mobsUser" class="logo_container" style="margin: 1rem auto">
        <img
          @click="refreshToken"
          src="img/rapihogarB.png"
          alt="RapiHogar"
          class="logo"
        />
      </div>
      <div v-else class="logo_container" style="margin: 2rem auto 3rem">
        <!-- <img @click="refreshToken" class="logo" src="/img/rapihogar.png" /> -->
        <!-- Logo AESA comienza -->
        <img @click="refreshToken" class="logo" src="../assets/img/aesa.webp" alt="Aseguradora del Este S.A." />
        <!-- Logo AESA termina -->

        <!-- comienza Logo SeguridadSeguros -->
        <!-- <img @click="refreshToken" class="logo" src="../assets/img/seguridadseguros.webp" alt="Seguridad Seguros" /> -->
        <!-- termina Logo SeguridadSeguros -->
      </div>
      <v-list dense>
        <template v-for="item in items">
          <v-row v-if="item.heading" :key="item.heading" align="center">
            <v-col cols="6">
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-col>
            <v-col cols="6" class="text-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-col>
          </v-row>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon=""
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item v-for="(child, i) in item.children" :key="i" link>
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item
            v-else-if="item.route == 'sign-out'"
            :key="item.text"
            @click="signOut"
            link
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <router-link v-else :key="item.text" :to="{ name: item.route }">
            <v-list-item :key="item.text" link @click="resetFilters()">
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="white">
      <v-app-bar-nav-icon
        color="primary"
        class="mobile-burger"
        @click.stop="
          drawer = !drawer;
          showSearchField = false;
          showFilters = false;
        "
      />
      <v-row align="center" justify="space-between" style="margin-right: 0">
        <v-toolbar-title
          style="color: #1b203f; font-weight: 600"
          class="ml-0 pl-4"
        >
          <span>{{ $store.state.app_title }}</span>
        </v-toolbar-title>
        <v-spacer />

        <!-- CAMPO BUSQUEDA DESKTOP -->
        <v-col
          md="3"
          v-show="
            $router.currentRoute.name == 'request-list' ||
            $router.currentRoute.name == 'pedido-detalle' ||
            $router.currentRoute.name == 'visit-list'
          "
        >
          <v-text-field
            autofocus
            ref="searchfield"
            outlined
            dense
            clearable
            v-model="searchTerm"
            @keyup="performSearch(searchTerm)"
            @click:clear="clearSearch()"
            flat
            hide-details
            prepend-inner-icon="mdi-magnify"
            label="Buscar"
            color="primary"
            class="mr-4 hidden-sm-and-down"
          />
        </v-col>
        <!-- FIN CAMPO BUSQUEDA DESKTOP -->

        <!-- ICONO DE BUSQUEDA SOLO MOBILE -->
        <v-icon
          v-show="
            $router.currentRoute.name == 'visit-list' ||
            $router.currentRoute.name == 'request-list' ||
            $router.currentRoute.name == 'pedido-detalle'
          "
          class="mr-4 hidden-md-and-up"
          color="primary"
          @click="
            showFilters = false;
            showSearchField = !showSearchField;
          "
        >
          search
        </v-icon>
        <!-- FIN ICONO DE BUSQUEDA -->

        <!-- MENU FILTROS -->
        <v-menu
          v-model="showFilters"
          :close-on-content-click="false"
          offset-y
          :position-y="57"
          absolute
          bottom
          style="width: 100vw"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-show="
                $router.currentRoute.name == 'request-list' ||
                $router.currentRoute.name == 'visit-list' ||
                $router.currentRoute.name == 'notification-list'
              "
              style="margin-right: 16px"
              :color="filterIconColor"
              v-bind="attrs"
              v-on="on"
            >
              filter_list
            </v-icon>
          </template>

          <v-card flat style="width: 100vw">
            <v-container>
              <v-row>
                <!-- SELECTOR ESTADO DE PEDIDO -->
                <v-col
                  cols="12"
                  v-show="$router.currentRoute.name == 'request-list'"
                >
                  <v-select
                    label="Estado"
                    outlined
                    v-model="selectedRequestStatus"
                    :items="$store.state.request_status_filters"
                    item-text="name"
                    item-value="value"
                    clearable
                    hide-details
                    flat
                  />
                </v-col>

                <!-- FIN SELECTOR ESTADO DE PEDIDO -->

                <!-- SELECTOR TIPO DE VISITA -->
                <v-col
                  cols="12"
                  v-show="$router.currentRoute.name == 'visit-list'"
                >
                  <v-select
                    label="Tipo de práctica"
                    outlined
                    v-model="selectedVisitType"
                    :items="$store.state.visits_type_filters"
                    item-text="name"
                    item-value="value"
                    clearable
                    hide-details
                    flat
                    value="1"
                  />
                </v-col>
                <!-- FIN SELECTOR TIPO DE VISITA -->

                <!-- VISIT STATUS FILTER -->
                <v-col
                  cols="12"
                  v-show="mobsUser && $router.currentRoute.name == 'visit-list'"
                >
                  <v-select
                    label="Estado"
                    outlined
                    v-model="selectedVisitStatus"
                    :items="$store.state.visits_status_filters"
                    item-text="name"
                    item-value="value"
                    clearable
                    hide-details
                    flat
                  />
                </v-col>
                <!-- END -->

                <!-- SELECTOR TIPO DE NOTIFICACIÓN -->
                <v-col
                  cols="12"
                  v-show="$router.currentRoute.name == 'notification-list'"
                >
                  <v-select
                    label="Tipo"
                    outlined
                    v-model="selectedNotificationType"
                    :items="$store.state.notification_types"
                    item-text="label"
                    item-value="name"
                    clearable
                    hide-details
                    flat
                    value="1"
                  />
                </v-col>
                <!-- FIN SELECTOR TIPO DE NOTIFICACIÓN -->

                <!-- SELECTOR ESTADO DE NOTIFICACIÓN -->
                <v-col
                  cols="12"
                  v-show="$router.currentRoute.name == 'notification-list'"
                >
                  <v-select
                    label="Estado"
                    outlined
                    v-model="selectedNotificationStatus"
                    :items="notificationStatuses"
                    item-text="text"
                    item-value="value"
                    clearable
                    hide-details
                    flat
                    value="1"
                  />
                </v-col>
                <!-- FIN SELECTOR ESTADO DE NOTIFICACIÓN -->

                <!-- SELECTOR COLUMNAS VISIBLES -->
                <v-col
                  class="hidden-sm-and-down"
                  cols="12"
                  v-show="
                    $router.currentRoute.name == 'request-list' ||
                    $router.currentRoute.name == 'visit-list'
                  "
                >
                  <!-- <v-select
                    label="Seleccionar columnas"
                    outlined
                    multiple
                    v-model="currentHeaders"
                    :items="computedHeaders"
                    @change="saveHeaders"
                    item-text="text"
                    item-value="value"
                    hide-details
                  /> -->
                </v-col>
                <!-- FIN SELECTOR COLUMNAS VISIBLES -->
              </v-row>
            </v-container>
          </v-card>
        </v-menu>
        <!-- FIN MENU FILTROS -->

        <!-- ICONO DE NOTIFICACIONES -->
        <v-icon
          v-show="
            $router.currentRoute.name == 'request-list' ||
            $router.currentRoute.name == 'visit-list'
          "
          color="primary"
          @click="$router.push('notification-list')"
        >
          notifications
        </v-icon>
        <div
          class="unread-notifications"
          v-show="
            $store.state.unread_notifications > 0 &&
            ($router.currentRoute.name == 'request-list' ||
              $router.currentRoute.name == 'visit-list')
          "
          @click="$router.push('notification-list')"
        >
          {{ $store.state.unread_notifications }}
        </div>
        <!-- FIN ICONO DE NOTIFICACIONES -->

        <!-- ICONO HOME -->
        <v-icon
          v-show="
            $router.currentRoute.name == 'notification-list' ||
            $router.currentRoute.name == 'notification'
          "
          color="primary"
          @click="$router.push('visit-list')"
        >
          home
        </v-icon>
        <!-- FIN ICONO HOME -->

        <!-- BOTON RECARGAR PEDIDO -->
        <v-btn
          v-show="$router.currentRoute.name == 'request-detail'"
          icon
          color="primary"
          @click="$store.commit('reload_request', true)"
        >
          <v-icon dark> refresh </v-icon>
        </v-btn>
        <!-- FIN BOTON RECARGAR PEDIDO -->
      </v-row>
    </v-app-bar>
    <v-alert
      v-if="showSnackbar"
      dense
      text
      type="warning"
      icon="mdi-wifi-strength-off-outline"
    >
      La conexión es inestable, es probable que la información de los pedidos no esté actualizada. Verificá tu conexión o esperá a que se restablezca
    </v-alert>
    
    <!-- CAMPO BUSQUEDA MOBILE -->
    <v-text-field
      flat
      solo
      hide-details
      clearable
      v-on:blur="showSearchField = false"
      v-show="showSearchField"
      v-model="searchTerm"
      @change="performSearch(searchTerm)"
      append-icon="mdi-magnify"
      label="Buscar"
      style="
        position: fixed;
        top: 0;
        left: 0;
        box-sizing: border-box;
        height: 56px;
        width: 100%;
        background: white;
        z-index: 5;
        border-radius: 0px;
        padding-top: 5px;
      "
      class="hidden-md-and-up"
      autofocus
    />
    <!-- FIN CAMPO BUSQUEDA MOBILE -->

    <!-- CONTENIDO PRINCIPAL -->

    <div class="app-content">
      <router-view :key="$route.fullPath"></router-view>
    </div>

    <!-- FIN CONTENIDO PRINCIPAL -->

    <!-- ALERTA -->

    <v-snackbar v-model="$store.state.snackbar.show" :timeout="5000">
      {{ $store.state.snackbar.text }}
    </v-snackbar>
    <NotificationRequestDialog
      v-show="!this.hasPermissionGranted"
    ></NotificationRequestDialog>
    <!-- FIN ALERTA -->
  </v-app>
</template>

<script>
import firebase from "firebase/app";
import "firebase/messaging";
import "firebase/auth";
import moment from "moment";
import qs from "querystring";
import HeadersRequests from "../assets/js/headersRequests";
import HeadersVisits from "../assets/js/headersVisits";
import AppLogo from "../components/Mobs/AppLogo.vue";
import NotificationRequestDialog from "../components/NotificationRequestDialog";
import { eventBus } from "../main"

export default {
  name: "Main",

  components: {
    NotificationRequestDialog,
    AppLogo,
  },

  data: () => ({
    notificationStatuses: [
      {
        text: "Leída",
        value: true,
      },
      {
        text: "No leída",
        value: false,
      },
    ],
    showSnackbar: false,
    users: [],
    currentHeadersVersion: null,
    currentUserEmail: null,
    baseURL: null,
    drawer: null,
    searchTerm: null,
    selectedNotificationType: null,
    selectedNotificationStatus: null,
    selectedRequestStatus: null,
    selectedVisitStatus: null,
    selectedVisitType: null,
    showSearchField: false,
    showFilters: false,
    tokenIsRefreshing: false,

    items: [
      { icon: "search", text: "Pedidos", route: "request-list" },
      { icon: "calendar_today", text: "Eventos", route: "visit-list" },
      {
        icon: "notifications",
        text: "Notificaciones",
        route: "notification-list",
      },
      { icon: "mdi-logout", text: "Cerrar sesión", route: "sign-out" },
    ],
  }),

  async mounted() {
    if (this.mobsUser) {
      this.items = [
        { icon: "calendar_today", text: "Mis prácticas", route: "visit-list" },
        {
          icon: "notifications",
          text: "Notificaciones",
          route: "notification-list",
        },
        { icon: "mdi-logout", text: "Cerrar sesión", route: "sign-out" },
      ];
    }

    moment.locale("es");
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("online", () =>
      this.$store.commit("connected", true)
    );
    window.addEventListener("offline", () =>
      this.$store.commit("connected", false)
    );

    if (window.navigator.onLine) {
      this.$store.commit("connected", true);
    } else {
      this.$store.commit("connected", false);
    }

    const user = JSON.parse(localStorage.getItem("user"));
    this.currentUserEmail = user && user.email;

    let baseURL = JSON.parse(localStorage.getItem("baseURL"));
    baseURL && (this.baseURL = baseURL);

    const userSettings = JSON.parse(localStorage.getItem("userSettings"));

    if (!user || !baseURL || !userSettings) {
      this.signOut();
    }

    const token = user && user.stsTokenManager.accessToken;
    this.$store.commit("set_user_settings", userSettings);

    this.axios.defaults.headers.common.Authorization = "JWT " + token;
    this.axios.defaults.baseURL = baseURL;

    this.axios.interceptors.request.use(async (request) => {
      if (this.shouldTokenRefresh() && !this.tokenIsRefreshing) {
        request.headers.Authorization = await this.refreshToken();
      }
      return request;
    });

    this.cacheSettings();

    this.handleSWEvents();

    this.sendTokenFcm();

    this.$store.commit("set_loading_requests", true);

    this.$store.commit("set_loading_notifications", true);

    await this.getCachedTechReqs();

    await this.getCachedNotifications();

    await this.getTechReqs();

    await this.getNotifications();

    this.updateHeadersIfNecessary();
  },

  created() {
    window.addEventListener('offline', this.handleOffline);
    window.addEventListener('online', this.handleOnline);

    eventBus.$on('badConnection', ()=> {
      this.showSnackbar = true;
    })
    eventBus.$on('goodConnection', ()=> {
      this.showSnackbar = false
    })

    this.checkConnection();
  },
  
  beforeDestroy() {
    window.removeEventListener('offline', this.handleOffline);
    window.removeEventListener('online', this.handleOnline);

    eventBus.$off('badConnection')
    eventBus.$off('goodConnection')
  },


  computed: {
    mobsUser() {
      return this.$store.state.mobsUser;
    },

    hasPermissionGranted() {
      return Notification.permission === "granted";
    },

    filterIconColor: function () {
      if (
        this.$store.state.visit_type ||
        this.$store.state.request_status ||
        this.$store.state.notification_type ||
        (this.$store.state.notification_status !== null &&
          this.$store.state.notification_status !== undefined)
      )
        return "rapired";
      return "primary";
    },
    
    computedHeaders: function () {
      let _headers = this.$store.state.headers;

      if (!this.$store.state.app_display_username) {
        _headers = _headers.filter((item) => item.value !== "client");
        _headers = _headers.filter(
          (item) => item.value !== "request.client.full_name"
        );
      }

      _headers = _headers.filter(
        (item) =>
          item.value !== "request.display_id" &&
          item.value !== "request.status_request.id" &&
          item.value !== "request_id" &&
          item.value !== "visit_status"
      );

      return _headers;
    },
  },

  watch: {
    "$store.state.headers": function (val, old) {
      this.currentHeaders = [];
      val.forEach((item) => {
        if (item.show) this.currentHeaders.push(item.value);
      });
    },

    "$store.state.authorised": function (val, old) {
      if (val === false) {
        this.signOut();
      }
    },

    // ! Revisar no está escuchando a ningun evento
    // "$store.state.updateCachedTechReq": function (techReq) {
    //   this.updateCachedTechReq(techReq);
    // },

    "$store.state.reload_data": async function (val) {
      if (val === true) {
        this.$store.commit("set_loading_requests", true);
        await this.getTechReqs();
        this.$store.commit("reload_data", false);
      }
    },

    "$store.state.refresh_notifications": async function (val) {
      if (val === true) {
        await this.getTechReqs();
        await this.getNotifications();
        this.$store.commit("refresh_notifications", false);
      }
    },

    selectedRequestStatus: function (val) {
      this.$store.commit("filter_requests_by_status", val);
    },

    selectedVisitType: function (val) {
      this.$store.commit("filter_visits_by_type", val);
    },

    selectedVisitStatus: function (val) {
      this.$store.commit("filter_visits_by_status", val);
    },

    selectedNotificationType: function (val) {
      this.$store.commit("filter_notifications_by_type", val);
    },

    selectedNotificationStatus: function (val) {
      this.$store.commit("filter_notifications_by_status", val);
    },
  },

  methods: {
    checkConnection() {
      if (!navigator.onLine) {
        this.showSnackbar = true;
      } else {
        this.showSnackbar = false;
      }
    },
    handleOffline() {
      this.showSnackbar = true;
    },
    handleOnline() {
      this.showSnackbar = false;
    },

    handleConnectionSlow() {
      this.showSnackbar = true
    },

    cacheSettings() {
      caches.open("data").then((cache) => {
        cache.put(
          "settings",
          new Response(
            JSON.stringify({
              email: this.currentUserEmail,
              baseURL: this.baseURL,
            })
          )
        );
      });
    },

    handleSWEvents() {
      const broadcast = new BroadcastChannel("webapp-tecnicos");

      /*
       !Comentado por Ruben
       broadcast.onmessage = event => {
        if (event.data && event.data.type === "REFRESH_DATA") {
          this.getCachedTechReqs();
          this.getCachedNotifications();
        }

        if (event.data && event.data.type === "REFRESH_CHAT"){
          console.log("REFRESH_CHAT: ", event.data.body);
          console.log("set_message_chat: ", event.data.body.data);
          this.$store.commit("set_message_chat", event.data.body.data);
        }
      }; */

      broadcast.onmessage = (event) => {
        if (event.data && event.data.type === "REFRESH_DATA") {
          this.getCachedTechReqs();
          this.getCachedNotifications();
        }

        if (event.data && event.data.type === "REFRESH_CHAT") {
          let notification = event.data.body;
          this.$store.commit("set_message_chat", notification.data);
        }
      };
    },

    updateHeadersIfNecessary() {
      const currentHeadersVersion = this.currentHeadersVersion;
      const storedHeadersVersion = Number(
        localStorage.getItem("storedHeadersVersion")
      );

      if (currentHeadersVersion !== storedHeadersVersion) {
        localStorage.setItem(
          "storedHeadersVersion",
          JSON.stringify(currentHeadersVersion)
        );
        localStorage.setItem(
          "headersRequests",
          JSON.stringify(HeadersRequests)
        );
        localStorage.setItem("headersVisits", JSON.stringify(HeadersVisits));
        this.$store.commit("updateHeaders");
      }
    },

    shouldTokenRefresh() {
      const currentDate = new Date();
      const currentTime = currentDate.getTime();
      const createdTime = Number(localStorage.getItem("lastTokenRefreshTime"));
      const elapsedTime = currentTime - createdTime;
      const expiryTime = 3000000;
      if (elapsedTime > expiryTime) return true;
      return false;
    },

    async getCachedNotifications() {
      const request = new Request(this.currentUserEmail + "/notifications");
      const cache = await caches.open("data");
      const _response = await cache.match(request);
      let response;
      if (_response) response = await _response.json();
      if (response) this.loadNotifications(response);
    },

    async getNotifications() {
      try {
        const response = await this.axios.get("/notification/");
        this.loadNotifications(response);
        this.cacheNotifications(response);
      } catch (error) {
        console.error("Error al obtener las notificaciones", error.message);
      }
    },

    getNotificationTypes(notifications) {
      const types = [];
      notifications.forEach((notification) => {
        !types.find(
          (type) => type.name === notification.notification_type.name
        ) && types.push(notification.notification_type);
      });
      return types;
    },

    loadNotifications(response) {
      try {
        const notifications = response.data.notifications;
        const unread = response.data.unread;
        const types = this.getNotificationTypes(notifications);
        this.$store.commit("set_notification_types", types);
        this.$store.commit("set_user_notifications", notifications);
        this.$store.commit("set_unread_notifications", unread);
        this.$store.commit("set_loading_notifications", false);
      } catch (error) {
        console.error("Error al cargar las notificaciones", error.message);
      }
    },

    cacheNotifications(response) {
      caches
        .open("data")
        .then((cache) => {
          cache.put(
            this.currentUserEmail + "/notifications",
            new Response(JSON.stringify(response))
          );
        })
        .catch((error) => console.error(error));
    },

    async getCachedTechReqs() {
      try {
        const request = new Request(
          this.currentUserEmail + "/request_technicians"
        );
        const cache = await caches.open("data");
        const _response = await cache.match(request);
        let response;
        if (_response) response = await _response.json();
        if (response) this.loadTechReqs(response);
      } catch (error) {
        console.error("Error al obtener pedidos del cache", error.message);
      }
    },

    async getTechReqs() {
      try {
        const response = await this.axios.get("/request_technician/");
        this.loadTechReqs(response);
        this.cacheTechReqs(response);
      } catch (error) {
        console.error(
          "Error al obtener los pedidos del técnico",
          error.message
        );
      }
    },

    loadTechReqs(response) {
      const _techReqList = response.data.request_technicians;
      let techReqList = [];

      for (const key in _techReqList) {
        techReqList.push(_techReqList[key]);
      }

      techReqList = techReqList.map((item) => {
        let displayId = item.request.id;
        if (item.request.external_id)
          displayId += " (" + item.request.external_id + ")";
        item.request = { ...item.request, display_id: displayId };
        return item;
      });

      this.currentHeadersVersion = response.data.v;

      const requestStatusFilters = response.data.request_filters[0].values;
      const visitTypeFilters = response.data.visits_filters[0].values;

      this.$store.commit("set_request_status_filters", requestStatusFilters);
      this.$store.commit("set_visits_type_filters", visitTypeFilters);

      if (this.$store.state.user_techReqs.length !== techReqList.length) {
        this.$store.commit("set_user_techReqs", techReqList);
      }

      const visitStatusFilters =
        response.data.visits_filters[1] &&
        response.data.visits_filters[1].values;

      if (visitStatusFilters) {
        this.$store.commit("set_visits_status_filters", visitStatusFilters);
      }

      this.$store.commit("set_loading_requests", false);
    },

    cacheTechReqs(response) {
      caches
        .open("data")
        .then((cache) => {
          cache.put(
            this.currentUserEmail + "/request_technicians",
            new Response(JSON.stringify(response))
          );
        })
        .catch((error) => console.error(error));
    },

    // ! Nunca se ejecuta updateCacheTechReq
    // async updateCachedTechReq(techReq) {
    //   console.log(techReq);

    //   try {
    //     const user = JSON.parse(localStorage.getItem("user"));
    //     const baseURL = JSON.parse(localStorage.getItem("baseURL"));
    //     const currentUserEmail = user.email;
    //     const request = new Request(currentUserEmail + "/request_technicians");
    //     const cache = await caches.open("data");
    //     const _response = await cache.match(request);
    //     let response;
    //     _response && (response = await _response.json());
    //     if (response) {
    //       response.data.request_technicians[techReq.id] = techReq;

    //       cache.put(
    //         baseURL + "visit/?email=" + currentUserEmail,
    //         new Response(JSON.stringify(response))
    //       );

    //       this.loadTechReqs(response);
    //     }
    //   } catch (error) {
    //     console.error("Error al actualizar cache de pedidos", error.message);
    //   }
    // },

    async refreshToken() {
      this.tokenIsRefreshing = true;
      const user = JSON.parse(localStorage.getItem("user"));
      const refreshToken = user.stsTokenManager.refreshToken;
      const body = { grant_type: "refresh_token", refresh_token: refreshToken };
      const config = {
        headers: { "content-type": "application/x-www-form-urlencoded" },
      };
      const response = await this.axios.post(
        "https://securetoken.googleapis.com/v1/token?key=AIzaSyCoWoENixUVHz43t4BfL0DK6fiMrmBKDs4",
        qs.stringify(body),
        config
      );
      this.axios.defaults.headers.common.Authorization =
        "JWT " + response.data.access_token;
      user.stsTokenManager.accessToken = response.data.access_token;
      user.stsTokenManager.refreshToken = response.data.refresh_token;
      localStorage.setItem("user", JSON.stringify(user));
      let currentTime = new Date();
      currentTime = currentTime.getTime();
      localStorage.setItem("lastTokenRefreshTime", currentTime);
      this.tokenIsRefreshing = false;
      return "JWT " + response.data.access_token;
    },

    getDeviceType() {
      const ua = navigator.userAgent;
      if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return "tablet";
      }
      if (
        /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
          ua
        )
      ) {
        return "mobile";
      }
      return "desktop";
    },

    sendTokenFcm() {
      const device = this.getDeviceType();
      if (firebase.messaging.isSupported()) {
        firebase
          .messaging()
          .getToken()
          .then((currentToken) => {
            console.log({ device, currentToken });
            if (currentToken && device) {
              this.axios
                .post("/notification_fcm/subscribe/", {
                  device: device,
                  token_fcm: currentToken,
                })
                .catch((error) => {
                  console.log({ error });
                  throw new Error(`Error al suscribir el token: ${error}`);
                });
            } else {
              console.log(
                "No Instance ID token available. Request permission to generate one."
              );
            }
          })
          .catch((err) => {
            console.log("error", err);
          });
      }
    },

    handleScroll() {
      this.showSearchField = false;
      this.showFilters = false;
    },

    resetFilters() {
      this.searchTerm = null;
      this.selectedRequestStatus = null;
      this.selectedVisitType = null;
      this.selectedVisitStatus = null;
      this.selectedNotificationType = null;
      this.selectedNotificationStatus = null;

      this.$store.commit("filter_notifications_by_status", null);
      this.$store.commit("filter_notifications_by_type", null);
      this.$store.commit("filter_requests_by_status", null);
      this.$store.commit("filter_visits_by_type", null);
      this.$store.commit("filter_visits_by_status", null);
      this.$store.commit("perform_search", null);
    },

    saveHeaders() {
      const newHeaders = [];

      this.$store.state.headers.forEach((item) => {
        const headerFound = this.currentHeaders.find(
          (itemB) => itemB === item.value
        );

        if (headerFound) {
          newHeaders.push({ ...item, show: true });
        } else {
          newHeaders.push({ ...item, show: false });
        }
      });

      this.$store.commit("set_headers", newHeaders);
    },

    signOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$store.commit("set_user_techReqs", []);
          this.$store.commit("setState");
          localStorage.clear();
          this.$router.push("login");
        })
        .catch((error) => console.error(error.message));
    },

    performSearch(term) {
      this.showSearchField = false;
      this.$store.commit("perform_search", term);
      window.scrollTo(0, 0);
    },

    clearSearch() {
      this.$store.commit("perform_search", null);
    },
  },
};
</script>

<style>
.unread-notifications {
  background-color: #c8272a;
  color: white;
  border-radius: 50%;
  height: 16px;
  width: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  right: 12px;
  top: 12px;
  position: absolute;
}
a {
  text-decoration: none;
  color: black;
}
a:active {
  text-decoration: none;
  color: black;
}
a:link {
  text-decoration: none;
  color: black;
}
a:visited {
  text-decoration: none;
  color: black;
}
a:hover {
  text-decoration: none;
  color: black;
}
.v-toolbar__title {
  overflow: visible !important;
}
.send_button {
  width: 60%;
}
.send_button_container {
  display: flex;
  justify-content: flex-end;
}
.translated {
  transform: translateY(100%);
}
.fullHeightSpacer {
  width: 100%;
  height: 100px;
}
.halfHeightSpacer {
  width: 100%;
  height: 50px;
}
.zeroHeightSpacer {
  width: 100%;
  height: 0px;
}
.logo_container {
  display: flex;
  width: 13.938rem;
}
.logo {
  object-fit: cover;
  width: 100%;
}
</style>
